import React from "react";
import store from "redux/Store";
import { CFOrgStatus, PageTableType, groupOrgStatus, groupType } from "../redux/Types";
import i18next from "i18next";
import { _PermittedContent } from '_module/utils/PermittedContent';
// import { _smReports } from '_module/definition/SmReports';
import getOrgSettings from './sys-calls/getOrgSettings';
import {NumericFormat as NumberFormat} from 'react-number-format';
import newCF from '_clearance/utils/newCF';
import Moment from 'react-moment';

const pad = (num) => {
  return ("0" + num).slice(-2);
};

export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes'
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export const secsToTime = (secs) => {
  var minutes = Math.floor(secs / 60);
  var hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  return `${pad(hours)}:${pad(minutes)}:${pad(Math.floor(secs % 60))}`.replace(/^00?:/, '');
};

export const titleCase = (str) => {
  var wordsArray = str.toLowerCase().split(/\s+/);
  var upperCased = wordsArray.map(function (word) {
    return word.charAt(0).toUpperCase() + word.substr(1);
  });
  return upperCased.join(" ");
}

export const userDisplay = (userId) => {
  const {
    inbox: { allUsers },
  } = store.getState();
  // return (allUsers.find((v) => +v.userId === +userId) || { name: "" }).name + " " + (allUsers.find((v) => +v.userId === +userId) || { email: "" }).email;
  let fomattedName = "";
  if(userId){
    if(userId.toString() == "-2"){
      fomattedName = "Soundmouse Neo Sync"; //Fix for ML20-5839
      return fomattedName;
    }
    let user = allUsers.find((v) => {
      if(v.externalRefId && typeof v.externalRefId == "string" && typeof userId == "string"){
        return v.externalRefId.toLowerCase() == userId.toLowerCase();
      }
    })
    if(user){
      fomattedName = getUserNameWithDetails(user);
    }
  }
  // return (getUserNameWithDetails(allUsers.find((v) => v.externalRefId === userId) || { name: " ", }));
  return (fomattedName);
}
export const userDisplayPrsPopUp = (userId) => {
  const {
    inbox: { allUsers },
  } = store.getState();
  // return (allUsers.find((v) => +v.userId === +userId) || { name: "" }).name + " " + (allUsers.find((v) => +v.userId === +userId) || { email: "" }).email;
  let fomattedName = "";
  if(userId){
    if(userId == "-2"){
      fomattedName = "Soundmouse Neo Sync"; //Fix for ML20-5839
      return fomattedName;
    }
    let user = allUsers.find((v) => {
      if(typeof userId == "string"){
        return v.userId.toLowerCase() == userId.toLowerCase();
      }
    })
    if(user){
      fomattedName = getUserNameWithDetails(user);
    }
  }
  // return (getUserNameWithDetails(allUsers.find((v) => v.externalRefId === userId) || { name: " ", }));
  return (fomattedName);
}
export const userDisplayInbox = (email) => {
  const {
    inbox: { allUsers },
  } = store.getState();
  // return (allUsers.find((v) => +v.userId === +userId) || { name: "" }).name + " " + (allUsers.find((v) => +v.userId === +userId) || { email: "" }).email;
  return (getUserNameWithDetails(allUsers.find((v) => v.email === email) || { name: " ", }));
}
export const userDisplayImage = (userId) => {
  const {
    inbox: { allUsers },
  } = store.getState();
  return (allUsers.find((v) => +v.userId === +userId) || { name: "Not found" }).imageUrl;
}


export const getUserDisplay = (userId) => {
  const {
    inbox: { allUsers },
  } = store.getState();
  let RefId = allUsers.find((v) => v.userId == userId ||  v.externalRefId == userId);
  let formattedName = "";
  if (RefId) {
    let user = allUsers.find((v) => {
      if (
        v.externalRefId &&
        typeof v.externalRefId == "string" &&
        typeof RefId.externalRefId == "string"
      ) {
        return (
          v.externalRefId.toLowerCase() == RefId.externalRefId.toLowerCase()
        );
      }
    });
    if (user) {
      formattedName = getUserNameWithDetails(user);
    }
  } else {
    if (userId == -2) {
      formattedName = "[Soundmouse Neo Sync]";
    }
    else if (userId == -1) {
      formattedName = "[Soundmouse PRS Check User]";
    }
    else if (userId == 1) {
      formattedName = "[System User]";
    }
    else if (userId){
       formattedName = "[ID:" + userId + "]";
    }
  }
  return <span title={formattedName}>{formattedName}</span>;
};

export const deepCopyFunction = (inObject) => {
  let outObject, value, key

  if (typeof inObject !== "object" || inObject === null || inObject instanceof Date) {
    return inObject // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {}

  for (key in inObject) {
    value = inObject[key]

    // Recursively (deep) copy for nested objects, including arrays
    outObject[key] = deepCopyFunction(value)
  }

  return outObject
}

export const getReadonlyFields = (runtime, cf) => {
  let hQ = [];

  if (runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST) {
    runtime._config.CF_HEADER_FIELD_LIST.forEach(field => {
      if (field.readOnly && field.readOnly.length > 0) {
        field.readOnly.forEach(condition => {
          if (condition.readOnlyCondition.every(cond => cf[cond.key] === cond.value)) {
            hQ.push(field.id)
          }
        });
      }
    });
  }

  return hQ;
}

export const getAddEpisodeList = (masterForm, newEpisodeCount = 0, totalEpisodeCount = 0, runtime ) =>{

  const { user } = store.getState();

  let newEpisodeTemplate = newCF(user, [], [], runtime);
  
  newEpisodeTemplate = {
    ...newEpisodeTemplate,
    clearanceFormType: masterForm.clearanceFormType,
    programmeType: runtime?._config?.PROGRAMME_TYPES?.EPISODE,
    selectedMasterForm: {
      id: masterForm.id,
    },
    selectedMasterFormId: masterForm.id,
    confirmed: []
  }
  const readOnlyHq = getReadonlyFields(runtime, newEpisodeTemplate) || [];
  if (readOnlyHq.length) {
    readOnlyHq.forEach(rv => {
      newEpisodeTemplate[rv] = masterForm[rv];
    });
  }
  if (masterForm.clearanceFormType === runtime?._config?.CLEARANCE_FORM_TYPE?.SPORT) {
    newEpisodeTemplate["masterTxDates"] = masterForm.txDates;
    newEpisodeTemplate["txDates"] = masterForm.txDates;
  }
  let newEpisodeList = [];
  for (let i = 0; i < newEpisodeCount; i++) {
    let epi = deepCopyFunction(newEpisodeTemplate);
    epi["name"] = `${masterForm.seriesTitle ? `${masterForm.seriesTitle} -` : ""} EPISODE ${totalEpisodeCount + (i)}`
    // if (newEpisodeTemplate.clearanceFormType === runtime?._config?.CLEARANCE_FORM_TYPE?.SPORT) {
    //   epi["prodNumber"] = `${masterForm?.prodNumber ? `${masterForm?.prodNumber}_` : ""}${i}_${new Date().valueOf()}`;
    //   epi["episodeTitle"] = `EPISODE ${totalEpisodeCount + (i)}`;
    // }
    if (newEpisodeTemplate.clearanceFormType === runtime?._config?.CLEARANCE_FORM_TYPE?.PROGRAMMING) {
      epi["episodeTitle"] = `EPISODE ${totalEpisodeCount + (i)}`;
      epi["episodeNumber"] = totalEpisodeCount + (i);
    }
    newEpisodeList.push(epi);
  }

  return newEpisodeList;
}

export const makeRandomId = (letters = 3, digits = 5) => {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var numbers = '0123456789';
  var charactersLength = characters.length;
  var numbersLength = numbers.length;
  for (var i = 0; i < letters; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  for (var i = 0; i < digits; i++) {
    result += numbers.charAt(Math.floor(Math.random() * numbersLength));
  }
  return result;
  //  return shuffleString(result);
}

export const shuffleString = s => {
  let shuffled = s.split('').reduceRight((res, _, __, s) => (res.push(s.splice(0 | Math.random() * s.length, 1)[0]), res), []);
  return shuffled.join('');
}

export const getFilteredStatus = (statuses, currentStatus, workFlowPermission = "default", hasRefer = false, hasUnClear = false) => {

  const {
    orgRuntime: {
      runtime: {
        _mlLicensingWorkflowPermissionOptions
      }
    }
  } = store.getState();

  let permittedStatuses = [];
  if (workFlowPermission == _mlLicensingWorkflowPermissionOptions.allAdmin.id) {
    return statuses
  }
  else if (workFlowPermission == _mlLicensingWorkflowPermissionOptions.musicRightsAdmin.id) {
    switch (currentStatus) {
      case CFOrgStatus.INPROGRESS:
        permittedStatuses = [CFOrgStatus.INPROGRESS];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.COMPLETED:
        permittedStatuses = [CFOrgStatus.COMPLETED];
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.WITHDRAWN:
        permittedStatuses = [CFOrgStatus.WITHDRAWN];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.REVIEWED:
        permittedStatuses = [CFOrgStatus.REVIEWED, CFOrgStatus.WITHDRAWN];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.SUBMITTED:
        permittedStatuses = [CFOrgStatus.SUBMITTED];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        if (!hasUnClear) permittedStatuses.push(CFOrgStatus.REVIEWED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      default:
        return statuses
    }

  }
  else {
    switch (currentStatus) {
      case CFOrgStatus.INPROGRESS:
        permittedStatuses = [CFOrgStatus.INPROGRESS];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        if (!hasUnClear) permittedStatuses.push(CFOrgStatus.SUBMITTED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.SUBMITTED:
        permittedStatuses = [CFOrgStatus.SUBMITTED, CFOrgStatus.WITHDRAWN];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.COMPLETED:
        permittedStatuses = [CFOrgStatus.COMPLETED, CFOrgStatus.WITHDRAWN];
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.WITHDRAWN:
        permittedStatuses = [CFOrgStatus.WITHDRAWN];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        if (!hasUnClear) permittedStatuses.push(CFOrgStatus.SUBMITTED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      case CFOrgStatus.REVIEWED:
        permittedStatuses = [CFOrgStatus.REVIEWED];
        if (!hasRefer && !hasUnClear) permittedStatuses.push(CFOrgStatus.COMPLETED);
        return statuses.filter(item => permittedStatuses.indexOf(item.id) != -1)
      default:
        return statuses
    }
  }


}

export const getUserNameWithDetails = (user) => {
  return ((user?.name?.trim().length > 0 ? user?.name?.trim() : (user?.email?.split("@")[0]) || user?.label || null));
}

export const getUserNameWithDetailsNew = (user) => {
  return (user?.name || user?.label) + " " + (user?.email ? `(${user?.email})` : "") + " " + (user?.orgName ? `/ ${user?.orgName}` : "");
}

export const getOrgNameWithId = (orgId) => {
  let orgName = "";

  switch (orgId) {
    case "sky":
      orgName = "Sky MusicBox";
      break;
    case "bbcmusicbox":
      orgName = "BBC MusicBox";
      break;
    case "soundmouse":
      orgName = "Soundmouse MusicBox";
      break;
    default:
      orgName = "";
      break;
  }
  return orgName
}

export const getContributorDetails = (contributor) => {
  return (contributor.map((item, i, array) => (
    <>
      <span title={stripedContributorField(item.role) + ": " + item.name}><i>{stripedContributorField(item.role)}</i>: <b>{item.name}{i === array.length - 1 ? null : ", "}</b></span>
    </>
  )))
}

export const getChangeLogDetails = (change) => {
  return change.map((item, i, array) => (
    <span>
      [
      <span title={"Action: " + (item.action ? item.action : "")}>
        <i>ACTION</i>: <b>{item.action ? item.action : ""}</b>,{" "}
      </span>
      <span
        title={"Date Created: " + (item.dateCreated ? item.dateCreated : "")}>
        <i>DATE CREATED</i>:{" "}
        <b>
          {item.dateCreated ? (
            <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
              {item.dateCreated}
            </Moment>
          ) : (
            ""
          )}
        </b>
        ,{" "}
      </span>
      <span title={"User Name: " + (item.userName ? item.userName : "")}>
        <i>USER NAME</i>: <b>{item.userName ? item.userName : ""}</b>
      </span>
      ]{i === array.length - 1 ? null : <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>}
    </span>
  ));
}

export const stripedContributorField = (field) => {
  let cField = field.replace("_", " ")
  return cField.toUpperCase();
}

export const hotKeyNavigate = (props, keyName, currentPage) => {
  const {
    orgRuntime: {
      runtime: {
        _mlPlaylists: _mlPlaylists,
        _mlAdmin: _mlAdmin,
        _manageMlUsers: _manageMlUsers,
        _mlLibraries: _mlLibraries,
        _playouts: _playouts,
        _contentRequest,
        _mlContentAdmin,
        _mlLicensing,
        _mlLicensingAdmin,
        _manageMlLiRules, 
        _smReports
      }
    }
  } = store.getState();
  if (keyName) {
    let isPermitted = false;
    switch (keyName) {
      case "alt+p":
        isPermitted = isPermissionGranted([_mlPlaylists]);
        if (currentPage != PageTableType.MYPLAYLIST && isPermitted) {
          props.history.push('/playlist')
        }
        break;
      case "alt+s":
        isPermitted = isPermissionGranted([_mlLibraries]);
        if (currentPage != PageTableType.SEARCH_TRACKS && isPermitted) {
          // props.history.push('/search/tracks')
          props.history.push({
            pathname: '/search/tracks',
            state: { autofocus: false },
          });
        }
        break;
      case "alt+c":
        isPermitted = isPermissionGranted([_mlLicensing]);
        if (currentPage != PageTableType.CLEARANCE_FORMS && isPermitted) {
          props.history.push('/mllicensing/forms')
        }
        break;
      case "alt+o":
        isPermitted = isPermissionGranted([_playouts]);
        if (currentPage != PageTableType.PLAYOUT && isPermitted) {
          props.history.push('/playout/playout-session')
        }
        break;
      case "alt+l":
        isPermitted = isPermissionGranted([_mlLicensingAdmin, _manageMlLiRules]);
        if (currentPage != PageTableType.LICENCING_ADMIN_RULES && isPermitted) {
          props.history.push('/mllicensingadmin/rules')
        }
        break;
      case "alt+w":
        isPermitted = isPermissionGranted([_mlContentAdmin]);
        if (currentPage != PageTableType.MLCADMIN_WORKSPACES && isPermitted) {
          props.history.push('/ml-admin/workspaces')
        }
        break;
      case "alt+r":
        isPermitted = isPermissionGranted([_contentRequest]);
        if (currentPage != PageTableType.CONTENT_REQUEST && isPermitted) {
          props.history.push('/content-tracker/requests')
        }
        break;
      case "alt+u":
        isPermitted = isPermissionGranted([_mlAdmin, _manageMlUsers]);
        if (currentPage != PageTableType.ADMIN_USERS && isPermitted) {
          props.history.push('/mladmin/users')
        }
        break;
      case "alt+t":
        isPermitted = isPermissionGranted([_smReports]);
        if (currentPage != PageTableType.REPORTS && isPermitted) {
          props.history.push('/reports')
        }
        break;
    }
  }
}
const isPermissionGranted = (permission) => {
  return _PermittedContent(permission)
    ? true
    : false;
};

export const trimSearchQuery = (query) => {
  try {
    query.q = query.q ? (typeof query.q != "string" ? query.q.toString().trim() : query.q.trim()) : query.q;
    query.filters = query.filters.map(d => {
      d.value = d.value.map(k => k ? (typeof k != "string" ? k.toString().trim() : k.trim()) : k);
      return d;
    })
  }
  catch (e) {
    console.error("trimSearchQuery", e);
  }
  return query;
};

export const getCFTypeList = () => {
  const {
    user: {
      id: userId,
    },
    inbox: { allGroups },
    clearanceRuntime: { runtime },
    orgRuntime: {
      runtime: {
        _mlLicensing, _mlLicensingCFTypeUserGroupRestrictions
      }
    }
  } = store.getState();

  let cfTypeList = (runtime && runtime._config && runtime._config.CLEARANCE_FORM_TYPE_LIST) ? runtime._config.CLEARANCE_FORM_TYPE_LIST : [];
  let cfTypePermission = _PermittedContent([_mlLicensing, _mlLicensingCFTypeUserGroupRestrictions]) ?? _mlLicensingCFTypeUserGroupRestrictions.default;

  let groups = [];

  if (allGroups && allGroups.length) {
    groups = allGroups.filter(g => (g.users?.length && g.users.includes(userId) && g.status === groupOrgStatus.ACTIVE))?.map(gg => { return gg.groupId }) ?? [];
  }


  if (cfTypePermission && groups.length && cfTypeList.length) {
    cfTypeList = cfTypeList.filter(cfType => {
      return cfType.permittedGroups.some(grp => groups.includes(grp));
    });
  }

  return cfTypeList;
}

export const sysCall = (f, params) => {

  switch (f) {
    case "getOrgSettings":
      return getOrgSettings(params)
  }
};

export const getfilterOptions = (type) => {
  const {
    orgRuntime: {
      runtime: {
        orgSettingType: orgSettingType,
        _albumMusicOrigins: albumOrigins,
        _trackMusicOrigins: trackOrigins,

      }
    }
  } = store.getState();
  let options = [];
  switch (type) {
    case "mladminSettingsTypeOption":
      options = [
        {
          id: orgSettingType.ssearch.id,
          label: i18next.t(`modules.${orgSettingType.ssearch.id}`),
        },

        {
          id: orgSettingType.asearch.id,
          label: i18next.t(`modules.${orgSettingType.asearch.id}`),
        },

        {
          id: orgSettingType.trackmetadata.id,
          label: i18next.t(`modules.${orgSettingType.trackmetadata.id}`),
        },

        {
          id: orgSettingType.albummetadata.id,
          label: i18next.t(`modules.${orgSettingType.albummetadata.id}`),
        },

      ];
      break;
    case "mlSearchAlbumCol":
      options = Object.values(albumOrigins);
      break;
    case "mlSearchAlbumTrackCol":
    case "mlSearchTrackCol":
    case "mlLicTrackInputCol":
      options = Object.values(trackOrigins);
      break;
  }
  return options
}

const getCfInputLimitationPermitted = () =>{
  const {
    orgRuntime: {
      runtime: {
        _mlLicensing,
        _mlLicensingCanCreateLimitations,
        _mlLicensingCanCreateLimitOptions
      }
    },
    user : { credentials : {orgID, orgs}}
   } = store.getState();

   let inputLimitation = _PermittedContent([_mlLicensing, _mlLicensingCanCreateLimitations],[]);
   if(inputLimitation && Array.isArray(inputLimitation) && !inputLimitation.length) return true;

   if(orgID && Array.isArray(orgs) && orgs.length > 0){
     let userGroups = orgs.find(o => o.id === orgID)?.groups;
     if(userGroups && Array.isArray(userGroups) && userGroups.length > 0){
       if(inputLimitation.includes(_mlLicensingCanCreateLimitOptions.cfTypeGroup.id)){
         let groups = userGroups.filter(g =>{ return g.split('_')[1] === `${groupType.CLEARANCE_TYPE}`});
         if(groups.length > 0) return true;
       }
       if(inputLimitation.includes(_mlLicensingCanCreateLimitOptions.cfGroup.id)){
         let groups = userGroups.filter(g =>{ return g.split('_')[1] === `${groupType.CLEARANCE}`});
         if(groups.length > 0) return true;
       }
       if(inputLimitation.includes(_mlLicensingCanCreateLimitOptions.extProdGroup.id)){
         let groups = userGroups.filter(g =>{ return g.split('_')[1] === `${groupType.EXTERNAL_PROD_COMPANY}`});
         if(groups.length > 0) return true;
       }
     }
   }
   return false;
}
export const canCreateClearanceForms = ()=>{
  const {
    orgRuntime: {
      runtime: {
        _mlLicensing,
        _mlLicensingCanCreate,
        _mlLicensingCanCreateOptions,
      }
    },
   } = store.getState();

   let canCreatePermission = _PermittedContent([ _mlLicensing, _mlLicensingCanCreate, ], _mlLicensingCanCreateOptions.yes.id);
   if(canCreatePermission === _mlLicensingCanCreateOptions.no.id){
    return false;
   }
   if(canCreatePermission === _mlLicensingCanCreateOptions.yes.id){
    return true;
   }
   if(canCreatePermission === _mlLicensingCanCreateOptions.limited.id){
    // return getCfInputLimitationPermitted();
    return true;
  }
  return false;
}

export const NumberDisplay = ({ value }) => {
  return (
    <NumberFormat
      value={value}
      displayType={'text'}
      thousandSeparator={true}
      prefix={'£'}
      renderText={formattedValue => <span title={formattedValue}>{formattedValue}</span>}
    />
  );
}

export const canEditClearanceForms = (createdBy)=>{
  const {
    orgRuntime: {
      runtime: {
        _mlLicensing,
        _mlLicensingCanRunWizard,
        _mlLicensingCanRunWizardOptions,
        _mlLicensingDefinitiontoCfOwn,
        _mlLicensingDefinitiontoCfOwnOptions,
      }
    },
    user : { credentials : {orgID, orgs}, externalRefId : userId}
   } = store.getState();

   let canEditPermission = _PermittedContent([ _mlLicensing, _mlLicensingCanRunWizard ], _mlLicensingCanRunWizardOptions.yes.id);

   if(canEditPermission === _mlLicensingCanRunWizardOptions.no.id){
    return false;
   }
   if(canEditPermission === _mlLicensingCanRunWizardOptions.yes.id || canEditPermission === _mlLicensingCanRunWizardOptions.yesLimited.id){
    // return canEditPermission === _mlLicensingCanRunWizardOptions.yes.id ? true : getCfInputLimitationPermitted();
    return true;
   }
   if(canEditPermission === _mlLicensingCanRunWizardOptions.own.id || canEditPermission === _mlLicensingCanRunWizardOptions.ownLimited.id){
    let ownPermited = false;
    let ownDefinition = _PermittedContent([_mlLicensing, _mlLicensingDefinitiontoCfOwn], []);
    if(ownDefinition && Array.isArray(ownDefinition) && !ownDefinition.length){
      ownPermited = true;
    }else{
      if(orgID && Array.isArray(orgs) && orgs.length > 0){
        let userGroups = orgs.find(o => o.id === orgID)?.groups;
        if(userGroups && Array.isArray(userGroups) && userGroups.length > 0){
          if(ownDefinition.includes(_mlLicensingDefinitiontoCfOwnOptions.user.id)){
            if(!createdBy){
              ownPermited = false;
            }else{
              if(userId === createdBy)ownPermited = true;
            }
          }
          if(ownDefinition.includes(_mlLicensingDefinitiontoCfOwnOptions.userGroupCfType.id)){
            let groups = userGroups.filter(g =>{ return g.split('_')[1] === `${groupType.CLEARANCE_TYPE}`});
            if(groups.length > 0) ownPermited = true;
          }
          if(ownDefinition.includes(_mlLicensingDefinitiontoCfOwnOptions.userGroup.id)){
            let groups = userGroups.filter(g =>{ return g.split('_')[1] === `${groupType.CLEARANCE}`});
            if(groups.length > 0) ownPermited = true;
          }
          if(ownDefinition.includes(_mlLicensingDefinitiontoCfOwnOptions.externalProductionCompany.id)){
            let groups = userGroups.filter(g =>{ return g.split('_')[1] === `${groupType.EXTERNAL_PROD_COMPANY}`});
            if(groups.length > 0) ownPermited = true;
          }
        }
      }
    }

    
    return canEditPermission === _mlLicensingCanRunWizardOptions.own.id ? ownPermited : (ownPermited && getCfInputLimitationPermitted());
   }

  return false;
}

export const escapeHtmlEntities = (query) => {
  if (!query || typeof query !== "string") {
    return query;
  }
  return query
    .replace(/\&lt\;/g, "<")
    .replace(/\&gt\;/g, ">")
    .replace(/\&amp\;/g, "&");
};

export const decodeHtmlEntitiesDeep = (v) => {
  if (typeof v === "string") return escapeHtmlEntities(v);
  if (Array.isArray(v)) return v.map(decodeHtmlEntitiesDeep);
  if (v && typeof v === "object") {
    const o = {};
    for (const k of Object.keys(v)) o[k] = decodeHtmlEntitiesDeep(v[k]);
    return o;
  }
  return v;
};

export function renderTextWithLinks(text) {
  if (!text) return null;

  // Split text by line breaks first to handle each line separately
  const lines = text.split(/\n/);
  const output = [];

  lines.forEach((line, lineIndex) => {
    // below regex will match: Markdown [label](https://url) |  full URLs like (https://example.com) | domain-only links like (example.com / www.example.com)
    const linkRegex =
      /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|((https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?)/g;

    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(line)) !== null) {
      if (match.index > lastIndex) {
        parts.push(
          <span key={`t-${lineIndex}-${lastIndex}`}>
            {line.slice(lastIndex, match.index)}
          </span>
        );
      }

      let href = "";
      let label = "";

      if (match[1] && match[2]) {
        // Markdown-style [label](url)
        label = match[1];
        href = match[2];
      } else if (match[3]) {
        // Raw URL or domain
        label = match[3];
        href = match[3].startsWith("http") ? match[3] : `https://${match[3]}`;
      }

      parts.push(
        <a
          key={`a-${lineIndex}-${match.index}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1a73e8", textDecoration: "underline" }}
        >
          {label}
        </a>
      );

      lastIndex = linkRegex.lastIndex;
    }

    if (lastIndex < line.length) {
      parts.push(
        <span key={`r-${lineIndex}-${lastIndex}`}>
          {line.slice(lastIndex)}
        </span>
      );
    }

    // Add the line with a <br /> at the end (except for the last line)
    output.push(<React.Fragment key={`line-${lineIndex}`}>{parts}</React.Fragment>);
    if (lineIndex < lines.length - 1) output.push(<br key={`br-${lineIndex}`} />);
  });

  return output;
}

export const getPlayerVolume = () =>  {
  return localStorage.getItem("playerVolume") ? JSON.parse(localStorage.getItem("playerVolume")) : 45;
};

